import React from 'react';
import { Link } from 'react-router-dom';

import { FluxStatusDtoStatusEnum } from 'lib_api/lib/api/gen';

import { FluxStatusIcon } from './FluxStatusIcon';

import './FluxStatuses.less';

interface FluxProps {
  title: string;
  status: FluxStatusDtoStatusEnum;
  url: string;
}

export const FluxStatus: React.FC<FluxProps> = ({ title, status, url }) => {
  return (
    <Link className={'link'} to={url} role="menuitem">
      <span>{title}</span>
      <FluxStatusIcon status={status} />
    </Link>
  );
};
